import axios from "axios";
import Vue from "vue";
import router from "@/router";
// 创建 axios 实例
let baseURL = "https://cqc-server-zuul.jsti-smart.cn";

const request = axios.create({
  // API 请求的默认前缀
  baseURL: baseURL,
  timeout: 600000, // 请求超时时间
  withCredentials: true,
  headers: {
    "Content-Type": "application/json; charset=utf-8"
  }
});

// request拦截器
request.interceptors.request.use(
  config => {
    const token = window.sessionStorage.getItem("tokenProcedure");
    // 让每个请求携带自定义 token
    config.headers["from"] = "app";
    // 如果 token 存在
    if (token) {
      config.headers["token"] = token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response拦截器
request.interceptors.response.use(
  response => {
    if (response.data && response.data.code === 401) {
      // 401, token失效
      Vue.cookie.delete("token");
      router.push({ name: "HomePage" });
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);
export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js